<template>
  <div>
    <div class="card">
      <div class="card-body">
        <h5 class="mb-4">
          <strong>Tambah Dokter Baru</strong>
        </h5>
        <a-form :form="form" @submit="handleSubmit">
          <a-form-item
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="Nama Lengkap"
          >
            <a-input
              :disabled="submitting"
              placeholder="Nama Lengkap"
              v-decorator="[
                'fullname',
                {
                  rules: [
                    { required: true, message: 'Nama lengkap harus diisi!' },
                  ],
                },
              ]"
            />
          </a-form-item>
          <a-form-item
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="Nomor KTP"
          >
            <a-input
              :disabled="submitting"
              placeholder="Nomor KTP"
              v-decorator="['idNumber']"
            />
          </a-form-item>
          <a-form-item
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="E-mail"
          >
            <a-input
              :disabled="submitting"
              placeholder="E-mail"
              v-decorator="['email']"
            />
          </a-form-item>
          <a-form-item
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="Verification Code"
          >
            <a-input
              :disabled="submitting"
              placeholder="Verification Code"
              v-decorator="[
                'verificationCode',
                {
                  rules: [
                    {
                      required: true,
                      message: 'Verification Code harus diisi!',
                    },
                  ],
                },
              ]"
            />
          </a-form-item>
          <a-form-item
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="Rumah Sakit"
          >
            <a-input
              :disabled="submitting"
              placeholder="Rumah Sakit"
              v-decorator="[
                'hospital',
                {
                  rules: [
                    {
                      required: true,
                      message: 'Nama rumah sakit harus diisi!',
                    },
                  ],
                },
              ]"
            />
          </a-form-item>
          <a-form-item
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="Provinsi"
          >
            <a-select
              :disabled="submitting"
              allowClear
              v-decorator="['province']"
              placeholder="Provinsi"
              @change="handleChangeProvince"
            >
              <a-select-option
                v-for="prov in provinceList"
                :key="prov"
                :value="prov"
              >
                {{ prov }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="Kota"
          >
            <a-select
              :disabled="submitting"
              allowClear
              v-decorator="['city']"
              placeholder="Kota"
            >
              <a-select-option
                v-for="city in cityList"
                :key="city.id"
                :value="city.name"
              >
                {{ city.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="Program"
          >
            <a-select
              mode="multiple"
              style="width: 100%"
              placeholder="Program Type"
              v-decorator="[
                'programTypes',
                {
                  rules: [
                    { required: true, message: 'Program Types harus diisi!' },
                  ],
                },
              ]"
            >
              <a-select-option
                v-for="(pro, i) in programTypes"
                :key="i"
                :value="pro.name"
                >{{ pro.name }}</a-select-option
              >
              <!-- <a-select-option value="TAGRISSO"> TAGRISSO </a-select-option>
              <a-select-option value="FASLODEX"> FASLODEX </a-select-option>
              <a-select-option value="LYNPARZA"> LYNPARZA </a-select-option>
              <a-select-option value="IMFINZI"> IMFINZI </a-select-option>
              <a-select-option value="CALQUENCE"> CALQUENCE </a-select-option> -->
              <!-- <a-select-option value="FASENRA"> FASENRA </a-select-option> -->
            </a-select>
          </a-form-item>
          <button
            type="submit"
            class="btn btn-success px-5"
            :disabled="submitting"
          >
            Simpan Data
          </button>
        </a-form>
      </div>
    </div>
  </div>
</template>
<script>
import router from '@/router'
import { getAll, getProvinces } from '@/services/axios/api/city'
import { create } from '@/services/axios/api/dokter'
import { notification } from 'ant-design-vue'
import apiClient from '../../../services/axios'

const labelCol = {
  xs: { span: 24 },
  sm: { span: 4 },
}
const wrapperCol = {
  xs: { span: 24 },
  sm: { span: 12 },
}
export default {
  data: function () {
    return {
      form: this.$form.createForm(this),
      labelCol,
      wrapperCol,
      cityList: [],
      submitting: false,
      programTypes: [],
      provinceList: [],
    }
  },
  created() {
    this.getProvinceList()
    this.getProgramType()
  },
  methods: {
    async getProvinceList() {
      const res = await getProvinces()
      this.provinceList = res
    },
    async handleChangeProvince(val) {
      this.form.setFieldsValue({
        city: undefined,
      })
      this.cityList = []
      await this.getCityList(val)
    },
    async getCityList(province) {
      const res = await getAll({ province })
      this.cityList = res
    },
    async getProgramType() {
      const res = await apiClient.get('/programType')
      this.programTypes = res.data
      // console.log(res.data, '<<<<')
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields(async (err, values) => {
        if (!err) {
          this.submitting = true
          console.log('Received values of form: ', values)
          try {
            const res = await create(values)
            if (res && res.data) {
              notification.success({
                message: 'Sukses',
                description: 'Data berhasil ditambahkan',
                duration: 5,
              })
              router.push('/dokter')
            }
            this.submitting = false
          } catch (e) {
            this.submitting = false
          }
        }
      })
    },
  },
}
</script>
